import React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useQuery } from '../hooks/useQuery';

const PAYMENTS = `
query GetPayments {
    payments {
        transaction
        dwelling
        product
        amount
        status
        capturedAt
        refundedAt
        reason
        metadata
        email
        name
    }
}
`;

const fallbackI18n = (text) => text;

const formatTimestamp = (item) => {
  const timestamp = item && (item.capturedAt || item.refundedAt);

  if (!timestamp || typeof timestamp !== 'string') {
    return '-';
  }

  return timestamp.replace(/T[0-9:.]+Z/, '');
};

const shortDwellingId = (dwelling) => {
  if (!dwelling || typeof dwelling !== 'string') {
    return '-';
  }

  return dwelling.substr(0, 8);
};

const PaymentDashboard = (props = {}) => {
  const i18n = props.i18n || fallbackI18n;

  const { data } = useQuery(PAYMENTS, {
    variables: {}
  });

  const payments = data && Array.isArray(data.payments) ? data.payments : [];

  return (
    <div>
      <Paper sx={{ width: '100%', overflowX: 'auto' }}>
        <Table sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow>
              <TableCell>{i18n('Dwelling')}</TableCell>
              <TableCell>{i18n('Name')}</TableCell>
              <TableCell>{i18n('Email')}</TableCell>
              <TableCell>{i18n('Product')}</TableCell>
              <TableCell>{i18n('Amount')}</TableCell>
              <TableCell>{i18n('Status')}</TableCell>
              <TableCell>{i18n('Timestamp')}</TableCell>
              <TableCell>{i18n('Reason')}</TableCell>
              <TableCell>{i18n('Lookup')}</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {payments.map((item = {}, index) => (
              <TableRow
                key={
                  item.transaction ||
                  `${item.dwelling || 'dwelling'}-${
                    item.email || 'email'
                  }-${index}`
                }
              >
                <TableCell>
                  {item.dwelling ? (
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={`/dwellings/${item.dwelling}/preview`}
                    >
                      {shortDwellingId(item.dwelling)}
                    </a>
                  ) : (
                    '-'
                  )}
                </TableCell>

                <TableCell>{item.name || '-'}</TableCell>
                <TableCell>{item.email || '-'}</TableCell>
                <TableCell>{item.product || '-'}</TableCell>
                <TableCell>{item.amount || '-'}</TableCell>
                <TableCell>{item.status || '-'}</TableCell>
                <TableCell>{formatTimestamp(item)}</TableCell>
                <TableCell>{item.reason || '-'}</TableCell>

                <TableCell>
                  {item.transaction ? (
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={`/payments/stripe/${item.transaction}`}
                    >
                      Stripe
                    </a>
                  ) : (
                    '-'
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </div>
  );
};

export default PaymentDashboard;
